/** Centralised data IDs for the Connectivity feature. */

export const VPC_PEERING_FORM_DATA_IDS = {
  closeModal: 'close-modal',
  submit: 'submit-peering',
  cancel: 'cancel-peering',
  failureHint: 'peering-failure-hint',
  additiveNote: 'peering-additive-note',
  name: 'name',
  vpcId: 'vpc_id',
  cidrRange: 'cidr_range',
  awsAccountId: 'aws_account_id',
  awsRegion: 'aws_region'
};

export const VPC_PEERING_CARD_DATA_IDS = {
  card: (connectionId: string) => `peering-card-${connectionId}`,
  edit: (connectionId: string) => `edit-peering-${connectionId}`,
  delete: (connectionId: string) => `delete-peering-${connectionId}`,
  changeInProgress: (connectionId: string) => `in-progress-${connectionId}`,
  statusTooltip: (connectionId: string) => `status-tooltip-${connectionId}`,
  name: (connectionId: string) => `peering-name-${connectionId}`,
  detailValue: (connectionId: string, field: string) => `detail-${field}-${connectionId}`,
  copy: (connectionId: string, field: string) => `copy-${field}-${connectionId}`
};

export const CONNECTIVITY_CARDS_DATA_ID = 'connectivity-cards';
